export const bundlesStateSelector = (state) => state.Bundle.bundles;
